var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alltitlStyle"},[_c('h2',{staticClass:"modTitlte"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.titleObj.title)}})]),(_vm.titleObj.p)?_c('p',{domProps:{"innerHTML":_vm._s(_vm.titleObj.p)}}):_vm._e(),_c('strong',[_vm._v(_vm._s(_vm.titleObj.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }